const SUBJECT_PAGINATION_NUMBER = 100

export default {
  namespaced: true,
  state: {
    modals: {
      journalEdit: {target: null},
      subjectQuery: {target: null},
      subjectAccept: {target: null},
      materialAppearance: {target: null},
      channelMessage: {target: null},
    },
    config: {
      subjectQuery: {
        keyword: null,
        prefs: [],
        kinds: []
      },
      subjectPagination: {
        number: SUBJECT_PAGINATION_NUMBER,
        page: 0,
      }
    }
  },
  actions: {
    async loadWorkspace({state, dispatch}, {channelId, workspaceId}) {
      await dispatch('restoreSubjectQuery')
      await dispatch('loadWorkspace', {channelId, workspaceId}, {root: true})
      await dispatch('loadSubject', {channelId, workspaceId})
      await dispatch('subscribeEvent', {channelId, workspaceId})
    },
    async unloadWorkspace({state, dispatch}, {channelId, workspaceId}) {
      await dispatch('unsubscribeEvent', {channelId, workspaceId})
      await dispatch('unloadSubject')
      await dispatch('unloadWorkspace', null, {root: true})
    },
    async subscribeEvent(context, {channelId, workspaceId}) {
      const tags = []
      if (context.state.config.subjectQuery.prefs.length > 0) {
        tags.push(context.state.config.subjectQuery.prefs)
      }
      if (context.state.config.subjectQuery.kinds.length > 0) {
        tags.push(context.state.config.subjectQuery.kinds)
      }

      await context.dispatch('subscribeEvent', {channelId, workspaceId, params: {
          'subject.tags': tags,
          'subject.keyword': context.state.config.subjectQuery.keyword
      }}, {root: true})
    },
    async unsubscribeEvent(context, {channelId, workspaceId}) {
      await context.dispatch('unsubscribeEvent', {channelId, workspaceId}, {root: true})
    },
    async setSubjectAcceptModalTarget(context, subject) {
      context.state.modals.subjectAccept.target = subject
    },
    async unsetSubjectAcceptModalTarget(context, subject) {
      context.state.modals.subjectAccept.target = null
    },
    async setJournalEditModalTarget(context, journal) {
      context.state.modals.journalEdit.target = {...journal}
    },
    async unsetJournalEditModalTarget(context, journal) {
      context.state.modals.journalEdit.target = null
    },
    async setSubjectQueryModalTarget(context) {
      context.state.modals.subjectQuery.target = JSON.parse(JSON.stringify(context.state.config.subjectQuery))
    },
    async unsetSubjectQueryModalTarget(context) {
      context.state.modals.subjectQuery.target = null
    },
    async storeSubjectQuery(context, { channelId, workspaceId, config }) {
      const data = JSON.stringify(config)
      context.state.config.subjectQuery = JSON.parse(data)
      localStorage.setItem('subjectQuery', data);

      await context.dispatch('unsubscribeEvent', {channelId, workspaceId})
      await context.dispatch('subscribeEvent', {channelId, workspaceId})
    },
    async restoreSubjectQuery(context) {
      if (localStorage.getItem('subjectQuery')) {
        context.state.config.subjectQuery = JSON.parse(localStorage.getItem('subjectQuery'))
      } else {
        await context.dispatch('clearSubjectQuery')
      }
    },
    async clearSubjectQuery(context) {
      context.state.config.subjectQuery = { keyword: null, kinds: [], prefs: []}
      localStorage.removeItem('subjectQuery')
    },
    async setMaterialAppearanceModalTarget(context, defaultMaterialAppearanceId) {
      context.state.modals.materialAppearance.target = defaultMaterialAppearanceId
    },
    async unsetMaterialAppearanceModalTarget(context, workspace) {
      context.state.modals.materialAppearance.target = null
    },
    async setChannelMessageModalTarget(context, channelMessage) {
      context.state.modals.channelMessage.target = {...channelMessage}
    },
    async unsetChannelMessageModalTarget(context) {
      context.state.modals.channelMessage.target = null
    },
    async loadSubject(context, {channelId, workspaceId}) {
      const tags = []
      if (context.state.config.subjectQuery.prefs.length > 0) {
        tags.push(context.state.config.subjectQuery.prefs)
      }
      if (context.state.config.subjectQuery.kinds.length > 0) {
        tags.push(context.state.config.subjectQuery.kinds)
      }

      const data = await context.dispatch(
        'fetchSubject',
        {
          channelId,
          workspaceId,
          subjectQuery: {
            keyword: context.state.config.subjectQuery.keyword,
            tags: tags,
            page: context.state.config.subjectPagination.page,
            number: context.state.config.subjectPagination.number,
          }
        },
        { root: true }
      )
      context.state.config.subjectPagination.page++
    },
    async unloadSubject(context) {
      context.state.config.subjectPagination = {
        page: 0,
        number: SUBJECT_PAGINATION_NUMBER,
      }
      await context.dispatch('clearSubject', null, { root: true })
    }
  },
  getters: {
    journalEditModalTarget(state) {
      return state.modals.journalEdit.target
    },
    subjectAcceptModalTarget(state) {
      return state.modals.subjectAccept.target
    },
    subjectQueryModalTarget(state) {
      return state.modals.subjectQuery.target
    },
    materialAppearanceModalTarget(state) {
      return state.modals.materialAppearance.target
    },
    channelMessageModalTarget(state) {
      return state.modals.channelMessage.target
    },
    subjectQuery(state) {
      return state.config.subjectQuery
    }
  }
}
